<template>
    <section :id="sectionId" class="section-container" :class="categoryClass(category)">
        <div class="title title-grid">
            <h2 class="title-main">{{ category }}<span class="title-sub">{{ title }}</span></h2>
        </div>
        <div class="item-list">
            <ul>
                <slot />
            </ul>
        </div>
        <slot name="chart"/>
    </section>
</template>

<script>
export default {
    props: ["category","title", "sectionId"],

    methods: {
        categoryClass(cate) {
            if(cate == "學生" || cate == "STUDENT") return "student";
            else if (cate == "教師" || cate == "TEACHER") return "teacher";
            else if (cate == "研究" || cate == "RESEARCH") return "research";
            else if (cate == "校務" || cate == "OTHER") return "other";
        }
    }
}
</script>

<style src="@/assets/css/overview.css" scoped> </style>